import React from "react";
import { LocalAreaTransportTypeValues } from "../../types/LocalAreaTransportAddons";
import * as s from "./LocalAreaTransportAddons.module.css";
import LondonTravelCard from "./LondonTravelCard";
import PlusbusCard from "./PlusbusCard";
const LocalAreaTransportAddons = ({ addons }) => {
  if (!(addons == null ? void 0 : addons.length))
    return null;
  return /* @__PURE__ */ React.createElement("div", {
    className: s.paddedContent
  }, addons == null ? void 0 : addons.map((addon) => {
    switch (addon.type) {
      case LocalAreaTransportTypeValues.LONDONTRAVELCARD:
        return /* @__PURE__ */ React.createElement(LondonTravelCard, {
          key: addon.type,
          ...addon
        });
      case LocalAreaTransportTypeValues.PLUSBUS:
        return /* @__PURE__ */ React.createElement(PlusbusCard, {
          key: addon.type,
          ...addon
        });
      default:
        return null;
    }
  }));
};
var LocalAreaTransportAddons_default = LocalAreaTransportAddons;
export {
  LocalAreaTransportAddons_default as default
};
